<template>
    <div>
        <div>
            <div id="preloader">
                <div class="spinner-border color-highlight" role="status"></div>
            </div>
        </div>
        <div id="page">
            <app-header/>
            <app-footer/>
            <app-sidebar/>
            <app-setting/>

            <PortalTarget name="offcanvas-modal-bottom" multiple />
            
            <app-highlights/>
            <app-bell/>

            <router-view />

            <app-android/>
            <app-ios/>
        </div>
    </div>
</template>

<script>
import Header from "@/components/partials/Header.vue"
import Sidebar from "@/components/partials/Sidebar.vue"
import Footer from "@/components/partials/Footer.vue"
import Bell from "@/components/partials/Bell.vue"
import Highlights from "@/components/partials/Highlights.vue"
import Setting from "@/components/partials/Setting.vue"

import Android from "@/components/offcanvas/Android.vue"
import Ios from "@/components/offcanvas/Ios.vue"

export default {
    methods: {
        darkMode(){
            var toggleDark = document.querySelectorAll('[data-toggle-theme]');
            function activateDarkMode(){
                document.getElementById('theme-check').setAttribute('content','#1f1f1f')
                document.body.classList.add('theme-dark');
                document.body.classList.remove('theme-light', 'detect-theme');
                for(let i = 0; i < toggleDark.length; i++){toggleDark[i].checked="checked"}
                localStorage.setItem('Quran-Theme', 'dark-mode');
                console.log('dark');
            }
            function activateLightMode(){
                document.getElementById('theme-check').setAttribute('content','#FFFFFF')
                document.body.classList.add('theme-light');
                document.body.classList.remove('theme-dark','detect-theme');
                for(let i = 0; i < toggleDark.length; i++){toggleDark[i].checked=false}
                localStorage.setItem('Quran-Theme', 'light-mode');
                console.log('light');
            }

            function setColorScheme() {
                const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches
                const isLightMode = window.matchMedia("(prefers-color-scheme: light)").matches
                window.matchMedia("(prefers-color-scheme: no-preference)").matches
                window.matchMedia("(prefers-color-scheme: dark)").addListener(e => e.matches && activateDarkMode())
                window.matchMedia("(prefers-color-scheme: light)").addListener(e => e.matches && activateLightMode())
                if(isDarkMode) activateDarkMode();
                if(isLightMode) activateLightMode();
            }

            var darkModeSwitch = document.querySelectorAll('[data-toggle-theme]')
            darkModeSwitch.forEach(el => el.addEventListener('click', () =>{
                if(document.body.className == "theme-light"){ removeTransitions(); activateDarkMode();}
                else if(document.body.className == "theme-dark"){ removeTransitions(); activateLightMode();}
                setTimeout(function(){addTransitions();},350);
            }));

            if(localStorage.getItem('Quran-Theme') == "dark-mode"){for(let i = 0; i < toggleDark.length; i++){toggleDark[i].checked="checked"}
            document.body.className = 'theme-dark';}
            if(localStorage.getItem('Quran-Theme') == "light-mode"){document.body.className = 'theme-light';} if(document.body.className == "detect-theme"){setColorScheme();}

            const darkModeDetect = document.querySelectorAll('.detect-dark-mode');
            darkModeDetect.forEach(el => el.addEventListener('click',() =>{
                document.body.classList.remove('theme-light', 'theme-dark');
                document.body.classList.add('detect-theme')
                setTimeout(function(){setColorScheme();},50)
            }))

            function removeTransitions(){var falseTransitions = document.querySelectorAll('.btn, .header, #footer-bar, .menu-box, .menu-active'); for(let i = 0; i < falseTransitions.length; i++) {falseTransitions[i].style.transition = "all 0s ease";}}
            function addTransitions(){var trueTransitions = document.querySelectorAll('.btn, .header, #footer-bar, .menu-box, .menu-active'); for(let i = 0; i < trueTransitions.length; i++) {trueTransitions[i].style.transition = "";}}
		},
        activatePage(){
			var activeMenu = document.querySelectorAll('[data-menu-active]');
			if(activeMenu){
				var activeData = activeMenu[0].getAttribute('data-menu-active');
				var activeID = document.querySelectorAll('#'+activeData)[0]
				activeID.classList.add('active-item')
			}
		},
        card_extender(){
            var windowHeight = 0;
            const cards = document.getElementsByClassName('card');
            for (let i = 0; i < cards.length; i++) {
                if(cards[i].getAttribute('data-card-height') === "cover"){
                    if (window.matchMedia('(display-mode: fullscreen)').matches) {
                        windowHeight = window.outerHeight;
                    }
                    if (!window.matchMedia('(display-mode: fullscreen)').matches) {
                        windowHeight = window.innerHeight;
                    }
                    var coverHeight = windowHeight + 'px';
                }
                if(cards[i].hasAttribute('data-card-height')){
                    var getHeight = cards[i].getAttribute('data-card-height');
                    cards[i].style.height= getHeight +'px';
                    if(getHeight === "cover"){
                        // var totalHeight = getHeight
                        cards[i].style.height =  coverHeight
                    }
                }
            }
        },
        setHighlights(){
            var highlightData = document.querySelectorAll('[data-change-highlight]');
            highlightData.forEach(el => el.addEventListener('click', () => {
                var highlight = el.getAttribute('data-change-highlight');
                var pageHighlight = document.querySelectorAll('.page-highlight');
                if(pageHighlight.length){pageHighlight.forEach(function(e){e.remove();});}
                var loadHighlight = document.createElement("link");
                loadHighlight.rel = "stylesheet";
                loadHighlight.className = "page-highlight";
                loadHighlight.type = "text/css";
                loadHighlight.href = 'styles/highlights/' + highlight +'.css';
                document.getElementsByTagName("head")[0].appendChild(loadHighlight);
                document.body.setAttribute('data-highlight', 'highlight-'+highlight)
                localStorage.setItem('Quran-Highlight', highlight)
                highlightData.forEach(el => {
                    el.querySelectorAll('i')[0].classList.remove('bi-check-circle-fill');
                    el.querySelectorAll('i')[0].classList.add('bi-circle');
                });
                el.querySelectorAll('i')[0].classList.remove('bi-circle');
                el.querySelectorAll('i')[0].classList.add('bi-check-circle-fill');
            }))
            var rememberHighlight = localStorage.getItem('Quran-Highlight');
            if(rememberHighlight){
                document.body.setAttribute('data-highlight', rememberHighlight);
                var loadHighlight = document.createElement("link");
                loadHighlight.rel = "stylesheet";
                loadHighlight.className = "page-highlight";
                loadHighlight.type = "text/css";
                loadHighlight.href = 'styles/highlights/' + rememberHighlight +'.css';
                if(!document.querySelectorAll('.page-highlight').length){
                    document.getElementsByTagName("head")[0].appendChild(loadHighlight);
                    document.body.setAttribute('data-highlight', 'highlight-'+rememberHighlight)
                }
                highlightData = document.querySelectorAll('[data-change-highlight]');
                highlightData.forEach(el => {
                    el.querySelectorAll('i')[0].classList.remove('bi-check-circle-fill');
                    el.querySelectorAll('i')[0].classList.add('bi-circle');
                });
                var highlightSelect = document.querySelectorAll('[data-change-highlight="'+rememberHighlight+'"]')[0];
                highlightSelect.querySelectorAll('i')[0].classList.remove('bi-circle');
                highlightSelect.querySelectorAll('i')[0].classList.add('bi-check-circle-fill');
            }
		},
    },
    components: {
        'app-header' : Header,
        'app-sidebar' : Sidebar,
        'app-footer' : Footer,
        'app-bell' : Bell,
        'app-highlights' : Highlights,
        'app-setting' : Setting,
        'app-android' : Android,
        'app-ios' : Ios
    }
}
</script>